import React from 'react'
import { Grid } from '@mui/material'

function JCAbout() {

    return (
        <div style={{ fontFamily: 'Raleway', fontSize: 20, marginLeft: 20 }}>
            <Grid container>
                <Grid item xs={12}>
                    <a href="#menu" className="navPanelToggle"><span className="fa fa-bars"></span></a>






                    <p>One of the greatest gifts you can give is the <br></br><b>gift of time</b>.</p>
                    <p>Redefining work to harness latent talent<br></br></p>
                </Grid>
                <p><b>1 million</b>  citizens</p>
                &nbsp;
                <p><b>25 million</b> untapped human hours by 2024</p>

                <Grid item xs={12}>
                    <header>
                        <h2>Purpose</h2>
                    </header>
                </Grid>
                <p>
                    Gift of Time Foundation and St Aloysius College launch Job Cred$ - an explosive internship program designed to get soon to graduate students get job ready

                    100 Students sign upto an 80 hour across 8 week experiential program where aptitude tests help students  discover the job they will enjoy doing the most and the skills to get the jobs…

                    Career counselling sessions then anchor them to their possible future careers

                    The intuitively designed 8 week internship engages with industry champions across non traditional jobs futures while helping them learn crucial work skills such as

                    - Resume writing
                    - Job interview skills
                    - Customer servicing experience
                    - Microsoft skills
                    - Process creation

                    This time bank pilot is the first ever to be launched and we wish the Job Cred$ team all the very best </p>






                <Grid item xs={12}>
                    <header>
                        <h2>Principles</h2>
                    </header>
                </Grid>
                <p>Everyone has something of value to share with someone else irrespective of their age, gender, circumstances or qualification.
                    <br></br>
                    Today building strong families, inclusive workforces and revitalising the earth or our neighbors is not considered work.<br></br>

                    Helping people to get comfortable with receiving and giving to further goodwill.</p>








                <br></br>


                <br></br>



                <Grid item xs={12}>
                    <header>
                        <h2>Socials</h2>
                    </header>
                </Grid>
                <Grid item xs={12}>
                    <a href="https://www.instagram.com/giftoftime_/" rel="noreferrer" target="_blank">Instagram</a>
                    <br></br>
                    <a href="https://www.facebook.com/" rel="noreferrer" target="_blank">Facebook</a><br></br>
                    <a href="mailto:siyakohli@gmail.com" rel="noreferrer" target="_blank">E-mail</a><br></br>
                    <a href="https://www.linkedin.com/company/gift-of-time-foundation-in/" target="_blank" rel="noreferrer">LinkedIn</a>
                </Grid>





                <br></br>


            </Grid>
        </div>


    )



}

export default JCAbout